import { horizontalRule, horizontalRuleContainer } from './HorizontalRule.css';

export {
  horizontalRule as postHorizontalRuleClass,
  horizontalRuleContainer as postHorizontalRuleContainerClass,
} from './HorizontalRule.css';

export const HorizontalRule = () => {
  return (
    <div className={horizontalRuleContainer}>
      <div className={horizontalRule} />
    </div>
  );
};
